<template>
  <div class="UserProfile">
    <div class="user-detail-card">
      <div class="top-line"></div>
      <div class="profile-section text-center">
        <!-- v-if="userProfile" -->
        <div class="relative profile-pic-outer">
          <img
            alt=""
            class="user-state-border"
            src="../assets/images/Active RA (Golden Circle).svg"
          />
          <div style="background-color: #ffff;">
            <img
              :src="serverHostName + userProfile.picture"
              v-if="userProfile.picture"
              class="profile-pic"
            />

            <img v-else src="../assets/images/avatar.jpg" class="profile-pic" />
          </div>
        </div>

        <div class="profile-details-section">
          <div class="font-08rem font-weight-600 top-margin-10 capitalize">
            {{ userProfile.full_name }}
          </div>

          <div class="input-label-gray top-margin-5">
            {{ userProfile.profession }}
          </div>
        </div>
      </div>
      <div class="bottom-line" style="background-color:#fff6e2">
        <span style="color:#C6A555">Email:</span>{{ userProfile.email }}
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import { serverAddr, serverHostName } from "../networkConfig";
import Hexagon from "@/components/Hexagon.vue";
import { EventBus } from "../eventBus";
import moment from "moment";
export default {
  name: "UserProfile",

  components: {
    Hexagon,
  },
  props: ["active_period"],

  data() {
    return {
      serverHostName: serverHostName,
      moment: moment,
      isAdmin: false,
    };
  },

  beforeCreate() {
    if (localStorage.getItem("profile")) {
      setTimeout(() => {
        var userProfile = JSON.parse(localStorage.getItem("profile"));

        var internalTeamList = [
          "mayur fegde",
          "krisha bid",
          "pallavi bid",
          "bhushan mali",
          "sumeet tarkas",
          "snehal patil",
        ];

        userProfile.full_name = userProfile.full_name.toLowerCase();

        if (
          internalTeamList.includes(userProfile.full_name) ||
          userProfile.email == "admin@stockants.com"
        ) {
          this.isAdmin = true;
        }
      }, 0);
    }
  },

  mounted() {
    EventBus.$on("profilePic", (data) => {
      this.userProfile.picture = data;
      // let profile = serverHostName+data;

      // let profile_data = JSON.parse(localStorage.getItem('profile'));
      // profile_data.picture = data;
      // localStorage.setItem('profile', JSON.stringify(profile_data));
      // // document.getElementById('desktopNav-profilePic').src =  URL.createObjectURL(data);
      // document.getElementById('mobileNav-profilePic').src =  profile;
    });
  },

  watch: {
    // active_period() {
    //   this.getLoggedInUsersDetails();
    // },
  },

  methods: {
    goToExpertStore() {
      if (this.userProfile.profession != "Retail Investor") {
        this.$router.push({
          path: "/expert-store",
          query: {
            user_id: this.userProfile.id,
            user: "individual",
            name: this.userProfile.full_name,
          },
        });
      }
    },
  },
  beforeDestroy() {
    EventBus.$off();
  },
  computed: {
    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem("profileData"));
    },
  },
};
</script>

<style lang="scss" scoped>
.UserProfile {
  .input-label-bold-gray {
    font-weight: 600;
  }
  .faded-border-bottom {
    display: block;
    border: none;
    color: #fff;
    height: 1px;
    background: -webkit-gradient(
      radial,
      50% 50%,
      0,
      50% 50%,
      450,
      from(#d3d0d0),
      to(#fff)
    );

    width: 70%;
    margin: 10px auto 25px;
  }

  .bottom-line {
    width: 100%;
    background-color: #f3f3f3;
    font-size: 10px;
    color: #000;
    font-weight: 600;
    margin: 0 auto;
    text-align: center;
    padding: 15px 0;
    border-radius: 0 0 10px 10px;
    .input-label-bold-gray {
      font-size: 10px;
    }
  }

  .user-detail-card {
    background-color: #ffff;
    margin: 70px 20px 30px;
    border-radius: 9px;
    box-shadow: 0px 3px 11px 2px #dcd6d6;
  }
  .profile-section {
    position: relative;
    z-index: 2;
  }
  .top-line {
    height: 20px;
    width: 100%;
    // background-color: #e72726;
    border-radius: 9px;
    position: relative;
    z-index: -1;
    top: -6px;
  }

  .profile-details-section {
    padding: 15px;
    padding-top: 50px;
  }
  .sebi-number-block {
    .text {
      padding: 7px 10px;
      font-size: 0.7rem;
      font-weight: 600;
    }
    i {
      font-weight: 800;
      font-size: 0.8rem;
    }
    .sebi {
      color: #ffff;
      border-radius: 8px 0 0 8px;
    }
    .number {
      border-radius: 0 8px 8px 0;
      background-color: #f2f2f2;
    }
  }

  .profile-pic-outer {
    width: 215px;
    display: flex;
    justify-content: center;
  }
  .profile-pic {
    height: 115px;
    width: 115px;
    -o-object-fit: cover;
    object-fit: cover;
    border-radius: 100%;
    position: absolute;
    bottom: -45px;
    z-index: -1;
    left: 24%;
    background-color: #ffff;
  }

  .user-state-border {
    position: absolute;
    bottom: -56px;
    width: 140px;
  }

  .rank-wrapper {
    position: absolute;
    bottom: -8px;
    right: 0;
    left: 0;
  }
  .more-details-section {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
  }
}
</style>
